/* eslint-disable no-template-curly-in-string */
const content = {
    paymentSelection: {
        description: 'To provide you greater choice and flexibility, we now use Clik2pay to process our payments.',
        selectionOptionsTitle: 'How would you like to pay?',
        interac: {
            title: 'Interac ',
            description: 'Pay now, direct from any bank in Canada with no payment fees.',
            learnMoreText: 'Learn more',
            learnMoreUrl: 'https://google.ca?test=Interac'
        },
        eft: {
            title: 'Automatic bank payments',
            description: 'Conveniently pay bills automatically when they\'re due, with no fees.',
            learnMoreText: 'Learn more',
            learnMoreUrl: 'https://google.ca?test=EFT'
        },
        selectButtonText: 'Select'
    },
    confirmSmartCode: {
        title: 'Complete your payment details',
        subtitle: 'Please fill out the form below to complete your payment with Interac®.',
        form: {
            nameLabel: 'Full Name',
            emailLabel: 'Email',
            mobileLabel: (isMobileRequired = false) => isMobileRequired ? 'Mobile Number' : 'Mobile Number (Optional)',
            amountLabel: 'Amount',
            accountIdLabel: (isAccountRequired = false) => isAccountRequired ? 'Account ID' : 'Account ID (Optional)',
            submitButtonLabel: 'Complete payment via Interac',
            invoiceNumberLabel: (isInvoiceRequired = false) => isInvoiceRequired ? 'Invoice Number' : 'Invoice Number (Optional)'
        },
        validation: {
            decimal: 'Must not have more than 2 decimals',
            email: 'Must be a valid email',
        },
        clik2payLogoAltText: 'Clik2pay logo',
        merchantLogoAltText: 'Merchant logo',
        interacLogoAltText: 'Interac logo',
        footerMessage: 'Interac is a registered trade-mark and the Interac logo is a trade-mark of Interac Corp. Used under licence.'
    }
}

export default content;